common.View.create('galaxy::habitats.website.partials.header.DatacenterDirectory', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.onTalkToUs();
        this.initCloseTalkToUs();
    },

    onTalkToUs()
    {
        this.element.find('.talkToUs')
            .on('click', (event) => {
                this.element.find('.fixedForm').toggleClass('tw-hidden');
                $(document.body).toggleClass('tw-overflow-hidden');
            });
    },

    initCloseTalkToUs()
    {
        this.element.find('.fixedForm').on('click keyup', (e) => {
            // Click is outside of search form?
            let container = this.element.find('.fixedForm .content');

            // Check if clicked outside the container or escape is pressed
            if (container.has(e.target).length === 0 || e.key === 'Escape') {
                this.element.find('.fixedForm').addClass('tw-hidden');
            }
        });
    }

});